import React from "react";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";

import { GreaterThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/GreaterThan";
import {
    IfThenExpression,
    IfThenStyle,
} from "../../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";
import { MultiplyExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/MultiplyExpression";
import { StringLengthExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringLengthExpression";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { LessThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/LessThanExpression";
import { XExecutableTester } from "../XExecutableTester";
import { getIfElseSimpleRule } from "../../../Expressions/Testing/LogicData";
import { StoryNode } from "../../StoryBook/StoryData";
import { OrGroup } from "../../../rule-engine-core/Expressions/Expressions/Logic/OrGroup";

function getIfThenExpression() {
    let exp = new ExpressionConfiguration();
    let baseExpression = new IfThenExpression();
    baseExpression.ifThenStyle = IfThenStyle.BRANCH_DATA_RETURN;
    baseExpression.showElseAsDefault = true;

    baseExpression.ifBranches[0].ifExpression.elements[0].variableName = "isEmployee";
    let subExpression = new MultiplyExpression();
    subExpression.value2.value = 10;
    subExpression.value1.variableName = "income";
    baseExpression.ifBranches[0].thenExpression.subExpression = subExpression;

    let greaterThan = new GreaterThanExpression();
    let strLen = new StringLengthExpression();

    strLen.value1.variableName = "person.name";
    greaterThan.value1.subExpression = strLen;
    greaterThan.value2.value = 5;

    let secondIf = baseExpression.addIfBranch();

    secondIf.ifExpression = new OrGroup();

    secondIf.ifExpression.elements[0].subExpression = greaterThan;

    let lessThan = new LessThanExpression();
    lessThan.value1.variableName = "age";
    lessThan.value2.value = 40;
    secondIf.ifExpression.add();

    secondIf.ifExpression.elements[1].subExpression = lessThan;
    secondIf.thenExpression.value = 1000;

    baseExpression.defaultOutput.value = 0;
    exp.expression = baseExpression;

    return exp;
}

function getLogicExpressionResultElseIfAtEnd(): ExpressionConfiguration {
    let exp = new ExpressionConfiguration();
    exp.executionResult = new NumberDataDefinition();

    let baseExpression = new IfThenExpression();
    baseExpression.ifThenStyle = IfThenStyle.DATA_RETURN;

    baseExpression.ifBranches[0].ifExpression.elements[0].variableName = "isEmployee";

    let greaterThan = new GreaterThanExpression();
    let strLen = new StringLengthExpression();
    strLen.value1.variableName = "person.name";

    greaterThan.value1.subExpression = strLen;
    greaterThan.value2.value = 5;

    let secondIf = baseExpression.addIfBranch();

    secondIf.ifExpression.elements[0].subExpression = greaterThan;
    secondIf.thenExpression.value = 20;

    // true result
    let subExpression = new MultiplyExpression();
    subExpression.value2.value = 10;
    subExpression.value1.variableName = "income";
    baseExpression.trueOutput.subExpression = subExpression;

    // false result
    baseExpression.defaultOutput.variableName = "income";

    exp.expression = baseExpression;

    return exp;
}

export const StatementRuleTester = [
    new StoryNode(
        () => {
            let expression = getIfThenExpression();
            return <XExecutableTester executable={expression} />;
        },
        "Shared",
        "Tester",
        "Statement Rule",
        "Default",
    ),
    new StoryNode(
        () => {
            let expression = getLogicExpressionResultElseIfAtEnd();

            return <XExecutableTester executable={expression} />;
        },
        "Shared",
        "Tester",
        "Statement Rule",
        "Data Return",
    ),
    new StoryNode(
        () => {
            let expression = getIfElseSimpleRule();

            return <XExecutableTester executable={expression} />;
        },
        "Shared",
        "Tester",
        "Statement Rule",
        "Logic",
    ),
];
